export default __webpack_public_path__ + "static/media/LogoVectorial.f0bfb42f.svg";